import { useEffect, useMemo, useState } from 'react';

import { TemplateModel } from 'templates/types';
import { API_URL } from 'utils/endpoints';
import processBackEndData from 'utils/processBackEndTemplate';

import { TemplatesResponse } from './types';

export default function useTemplatesData(query: string) {
  const [data, setData] = useState<TemplateModel[]>([]);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (async function getData() {
      try {
        const res = await fetch(
          `${API_URL}/web-search/template/?q=${encodeURIComponent(query)}&offset=0&limit=60`,
        );

        if (!res.ok) {
          throw new Error(`Status error fetching templates: ${res.status}`);
        }
        const parsed: TemplatesResponse = await res.json();

        const processedData = processBackEndData(parsed.response.items);

        setData(processedData);
      } catch (err) {
        console.error(err);
      }
      setIsFetching(false);
    })();
  }, [query]);

  return useMemo(() => ({ data, isFetching }), [data, isFetching]);
}
